import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setBusy(true);
    try {
      await signup(name, email, password);
      toast.success("Welcome to the studio");
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup failed");
    }
    setBusy(false);
  };

  return (
    <main data-testid="signup-page" className="min-h-screen bg-[#0D0C0A] pt-32 pb-24 px-6 flex items-center justify-center">
      <div className="w-full max-w-md">
        <p className="label-eyebrow mb-4">Begin your journey</p>
        <h1 className="font-display text-4xl sm:text-5xl mb-10">Join the <span className="italic text-[#D4AF37]">studio</span>.</h1>

        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="label-eyebrow block mb-3">Your name</label>
            <input
              data-testid="signup-name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full bg-transparent border-b border-[#332D29] focus:border-[#D4AF37] focus:outline-none py-3 text-[#F5F2EB] placeholder:text-[#B3AFA8]/50"
              placeholder="Jane Porter"
            />
          </div>
          <div>
            <label className="label-eyebrow block mb-3">Email</label>
            <input
              data-testid="signup-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-[#332D29] focus:border-[#D4AF37] focus:outline-none py-3 text-[#F5F2EB] placeholder:text-[#B3AFA8]/50"
              placeholder="you@studio.com"
            />
          </div>
          <div>
            <label className="label-eyebrow block mb-3">Password</label>
            <input
              data-testid="signup-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-[#332D29] focus:border-[#D4AF37] focus:outline-none py-3 text-[#F5F2EB] placeholder:text-[#B3AFA8]/50"
              placeholder="at least 6 characters"
            />
          </div>
          <button type="submit" disabled={busy} data-testid="signup-submit" className="btn-gold w-full py-4 rounded-full text-sm mt-4 disabled:opacity-60">
            {busy ? "Preparing your seat…" : "Join the Studio"}
          </button>
        </form>

        <p className="text-[#B3AFA8] text-sm mt-10 text-center">
          Already a student?{" "}
          <Link to="/login" className="text-[#D4AF37] hover:underline">Sign in</Link>.
        </p>
      </div>
    </main>
  );
}
